import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The GIF Object`}</h2>
    <p>{`GIF Objects are returned from most of GIPHY API's Endpoints. These objects contain a variety of information, such as the Image Object, which itself includes the URLS for multiple different GIFS formats and sizes.`}</p>
    <div className="props-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Property`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Example`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`type:`}</strong>{` `}<em parentName="td">{`string(default:"gif")`}</em><br />{`By default, this is almost always GIF.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"gif"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`id:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{` This GIF's unique ID`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"YsTs5ltWtEhnq"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`slug:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The unique slug used in this GIF's URL`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"confused-flying-YsTs5ltWtEhnq"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The unique URL for this GIF`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"http://giphy.com/gifs/confused-flying-YsTs5ltWtEhnq"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`bitly_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The unique bit.ly URL for this GIF`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"http://gph.is/1gsWDcL"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`embed_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`A URL used for embedding this GIF`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"http://giphy.com/embed/YsTs5ltWtEhnq"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`username:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The username this GIF is attached to, if applicable`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"JoeCool4000"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`source:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The page on which this GIF was found`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"http://www.reddit.com/r/reactiongifs/comments/1xpyaa/superman_goes_to_hollywood/"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`rating:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The MPAA-style rating for this content. Examples include Y, G, PG, PG-13 and R`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"g"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`content_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`Currently unused`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`user:`}</strong>{` `}<a href="/docs/api/schema#user-object">{`User`}</a><br />{`An object containing data about the user associated with this GIF, if applicable.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`source_tld:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The top level domain of the source URL.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"cheezburger.com"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`source_post_url:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The URL of the webpage on which this GIF was found.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"http://cheezburger.com/5282328320"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`update_datetime:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The date on which this GIF was last updated.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"2013-08-01 12:41:48"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`create_datetime:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The date this GIF was added to the GIPHY database.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"2013-08-01 12:41:48"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`import_datetime:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The creation or upload date from this GIF's source.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"2013-08-01 12:41:48"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`trending_datetime:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The date on which this gif was marked trending, if applicable.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"2013-08-01 12:41:48"`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`images:`}</strong>{` `}<a href="/docs/api/schema#image-object">{`Images`}</a><br />{`An object containing data for various available formats and sizes of this GIF.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}><strong parentName="td">{`title:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`The title that appears on giphy.com for this GIF.`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}><inlineCode parentName="td">{`"Happy Dancing GIF"`}</inlineCode></td>
          </tr>
        </tbody>
      </table>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      